import { IconButton, IconButtonProps, Tooltip } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/styles';
import clsx from 'clsx';

import { styles } from './DownloadCSVButton.styles';

import { Icon } from '~ui-kit';

export type DownloadCSVButtonProps = IconButtonProps &
  WithStyles<typeof styles> & {
    tooltip?: string;
  };

export const DownloadCSVButton = withStyles(styles)(
  ({ classes, tooltip = 'Download CSV file', ...props }: DownloadCSVButtonProps) => (
    <Tooltip title={tooltip} placement="top">
      <IconButton {...props} classes={{ root: clsx(classes.root) }}>
        <Icon icon="system-filled" classes={{ root: clsx(classes.icon) }} />
      </IconButton>
    </Tooltip>
  )
);
